import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Tooltip } from 'react-bootstrap';

/* Function */
import ObjGeneral from '../function/';
/* Local store */
import { localStoreFN } from '../../store/localStorage.js';

/* Actions */
import * as detail_roadwarningActions from '../../actions/detail_roadwarning/index';
import * as driverRoadwarningActions from '../../actions/driver_roadwarning/index';

/* Components */
import Header from '../../components/detail_roadwarning/header';
import MicrosleepsKpiEvolutionGraph from '../../components/common/roadwarning/microsleepsKpiEvolutionGraph';
import MicrosleepsQuantityEvolutionGraph from '../../components/common/roadwarning/microsleepsQuantityEvolutionGraph';
import TitleMain from '../../components/common/titleMain';
import Label from '../../components/common/label';
import RankingTable from '../../components/common/tables/rankingTable';
import CircularIndicator from '../../components/common/indicators/circularIndicator';
import SimpleIndicator from '../../components/common/indicators/simpleIndicator';
import Avatar from '../../components/common/avatar';
import Loading from '../../components/common/loading';
import Message from '../../components/common/message';
import AvatarImg from '../../../../public/images/empresa.png';
import Expired from '../expired/index.jsx';

class Detail_roadwarning extends Component {
  constructor(props) {
    super(props);
  }

  componentWillUnmount() {
    this.props.actions.resetDetailRoadWarning();
  }

  async componentDidMount() {
    const permits = localStoreFN().getItem('permits');
    const permit = permits.includes('roadwarning');
    if (permit) {
      if (this.props.setting) {
        const obj = JSON.parse(this.props.setting.value);
        if (obj.generalSetting.views.includes('roadwarning')) {
          const dateStart = this.props.filters.date.fechaStartFinal || null;
          const dateEnd = this.props.filters.date.fechaEndFinal || null;
          const tags = this.props.filters.tags;
          await this.props.actions.fetchDetail_roadwarningApi({
            dateStart,
            dateEnd,
            tags
          });
        } else {
          this.props.history.push('/dashboard/authorization');
        }
      }
    } else {
      this.props.history.push('/dashboard/authorization');
    }
  }

  handleSubmit = async obj => {
    /* GROUP */
    const format = this.props.language.account.date.format;
    /* TAGS */
    const tags = ObjGeneral.getTags(obj);
    /* DATE */
    const date = ObjGeneral.getDate(obj, format);

    this.props.actions.setFilterDetailRoadWarning({
      tags: tags,
      date: date
    });
    await this.props.actions.fetchDetail_roadwarningApi({
      tags: tags,
      dateStart: date.fechaStartFinal,
      dateEnd: date.fechaEndFinal
    });
  };

  link = event => {
    const format = this.props.language.account.date.format;
    const date = ObjGeneral.getDate({ id: null }, format);
    const tags = this.props.filters.tags;

    const driver = {
      id: event.currentTarget.dataset.driverid,
      alias: event.currentTarget.dataset.driveralias
    };
    document.getElementById('menu-2-sub-2').classList.remove('active');
    document.getElementById('menu-2-sub-3').classList.add('active');
    this.props.driverActions.setFilterDriverRoadWarning({
      tags: tags,
      date: date,
      driver: driver
    });
    this.props.history.push('/dashboard/driver_roadwarning');
  };

  render() {
    if (this.props.setting) {
      const obj = JSON.parse(this.props.setting.value);
      const setting = ObjGeneral.getSetting({
        setting: obj.detailRoadWarning,
        filter: this.props.filter,
        general: obj.generalSetting
      });
      const { graphColorRange } = obj;
      const language = this.props.language ? this.props.language.filter : '';
      return (
        <section className="main full-height detail-roadwarning">
          <Header
            loadingFilter={this.props.loadingFilter}
            filters={this.props.filters}
            filter={setting.filter}
            date={this.props.dateMax[1]}
            handleSubmit={this.handleSubmit}
            language={language}
          />
          {this.props.loading ? (
            <Loading language={this.props.language} />
          ) : this.props.status === 401 || this.props.statusTags === 401 ? (
            <Expired
              history={this.props.history}
              language={this.props.language ? this.props.language : ''}
            />
          ) : this.props.status === 200 && this.props.statusTags === 200 ? (
            <div className="main-container">
              <div className="left-col">
                <div className="top-left-section">
                  <div className="vertical-container">
                    <section className="operation-info">
                      <Avatar width={150} src={`${AvatarImg}`} />
                      <section className="microsleeps-kpi-wrapper">
                        <CircularIndicator
                          size={130}
                          max={100}
                          value={this.props.datos.warningRate}
                          forceValue={100}
                          fill={true}
                          valueFormat={{ type: 'NUMBER', format: '.1f' }}
                          graphColorRange={graphColorRange.roadWarningRate}
                        />
                        <Label
                          label={this.props.language.detail_roadwarning.labels.microsleepsKpi}
                        />
                      </section>
                    </section>
                  </div>
                </div>
                <section className="operation-ranking">
                  <TitleMain title={this.props.language.detail_roadwarning.title.ranking} />
                  {this.props.datos.ranking.length > 0 && (
                    <RankingTable
                      language={this.props.language}
                      link={this.link}
                      data={this.props.datos.ranking}
                      nameColumn={'driverAlias'}
                      kpiColumn={'avg'}
                      kpiFormat={'.1f'}
                      filter={setting.filter}
                      graphColorRange={graphColorRange.roadWarningRate}
                    />
                  )}
                </section>
              </div>
              <div className="right-col">
                <section className="operation-evolution">
                  <TitleMain
                    className={'second'}
                    title={this.props.language.detail_roadwarning.title.evolution}
                  />
                  {this.props.datos.dailyWarningRate.length > 0 && (
                    <MicrosleepsKpiEvolutionGraph
                      data={this.props.datos.dailyWarningRate}
                      graphColorRange={graphColorRange.roadWarningRate}
                      tooltip={this.props.language.driver_roadwarning.labels}
                      language={this.props.language}
                    />
                  )}
                </section>
                <section className="operation-quantity-evolution">
                  <TitleMain
                    className={'second'}
                    title={this.props.language.detail_roadwarning.title.quantityEvolution}
                  />
                  {this.props.datos.dailyTotalWarnings.length > 0 && (
                    <MicrosleepsQuantityEvolutionGraph
                      data={this.props.datos.dailyTotalWarnings}
                      graphColorRange={graphColorRange.roadWarningQuantity}
                      tooltip={this.props.language.detail_roadwarning.labels.graphTooltip}
                      language={this.props.language}
                    />
                  )}
                </section>
                <section className="operation-indicators">
                  <TitleMain
                    className={'second'}
                    title={this.props.language.detail_roadwarning.title.totalEvents}
                  />
                  <div className="indicators-row">
                    <div className="indicators-cell">
                      <SimpleIndicator
                        value={this.props.datos.warningTotal}
                        valueFormat={{ type: 'NUMBER', format: '.0f' }}
                        graphColorRange={graphColorRange.roadWarningQuantity}
                      />
                      <Label
                        label={this.props.language.detail_roadwarning.labels.totalMicrosleeps}
                      />
                    </div>
                  </div>
                </section>
              </div>
              <Tooltip placement="top" id="pageTooltip" />
            </div>
          ) : this.props.status === 500 || this.props.statusTags === 500 ? (
            <Message message={this.props.language.error.apiError500} />
          ) : (
            <Message message={this.props.language.error.apiError} />
          )}
        </section>
      );
    } else {
      return (
        <section className="main">
          <Message message="NO Setting" />
        </section>
      );
    }
  }
}
const mapStateToProps = state => ({
  filter: state.reducer.tags.filter,
  statusTags: state.reducer.tags.status,
  loadingFilter: state.reducer.tags.loading,

  language: state.reducer.dashboard.language,
  dateMax: state.reducer.dashboard.dateMax,
  setting: state.reducer.dashboard.setting,
  datos: state.reducer.detail_roadwarning.datos,
  loading: state.reducer.detail_roadwarning.loading,
  status: state.reducer.detail_roadwarning.status,
  filters: state.reducer.detail_roadwarning.filters
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(detail_roadwarningActions, dispatch),
  driverActions: bindActionCreators(driverRoadwarningActions, dispatch)
});

Detail_roadwarning.propTypes = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Detail_roadwarning);



// WEBPACK FOOTER //
// ./source/client/containers/detail_roadwarning/index.jsx